<template>
  <div class="value-with-label">
    <div class="the-label" v-if="label">
      {{ label}}
    </div>
    <div class="the-value">
      <slot></slot>
    </div>
  </div>
</template>

<script>

  export default {
    name: "ValueWithLabel",
    props: {
      label: String,
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Partials/Controls/ValueWithLabel.vue